import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../panel/components/Siderbar.jsx";
import Header from "../panel/components/Header.jsx";
import { loadCSS, removeCSS } from "../utils/domAssets.js";

export default function PanelLayout() {
  const [isLoading, setIsLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function loadStyles() {
      await Promise.all([
        loadCSS(
          "https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&family=Inter:wght@400;500;600;700&display=swap",
          "website-fonts",
        ),
        loadCSS("/assets/panel/css/style.css", "panel-css"),
        loadCSS("/assets/panel/css/dashboard.css", "dashboard-css"),
        loadCSS("/assets/panel/css/fleet-owner.css", "fleet-owner-css"),
      ]);

      if (isMounted) {
        setIsLoading(false);
      }
    }

    loadStyles();

    return () => {
      isMounted = false;
      removeCSS("website-fonts");
      removeCSS("panel-css");
      removeCSS("dashboard-css");
      removeCSS("fleet-owner-css");
    };
  }, []);

  if (isLoading) {
    return (
      <div className="website-loader">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="dash-body">
      <div className="dash-shell">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div
          className={`sidebar-backdrop${sidebarOpen ? " show" : ""}`}
          onClick={() => setSidebarOpen(false)}
        />
        <div className="dash-main">
          <Header onToggleSidebar={() => setSidebarOpen((v) => !v)} />
          <Outlet />
        </div>
      </div>
      <div className="toast" id="toast" />
    </div>
  );
}
